// constants
import { UNAUTHENTICATED_ENDPOINTS } from '@/constants/login';
export const isUnauthenticatedApi = (url) => {
    return UNAUTHENTICATED_ENDPOINTS.some((endpoint) => url.includes(endpoint));
};
